import React from 'react';
import classNames from 'classnames';
import './geoDirection.scss'

export const GeoDirection: any = (props: any) => {
  const {
    origin,
    destination,
    hasError = false,
    apiKey = window.tz_globalConfigs.googleMapsApiKey,
  } = props;

  const classes = classNames({
    'map': true,
    error: hasError,
  });

  const size = '793x500';
  const markerA = `color%3Ared|label%3AA|${origin.lat}%2C${origin.lng}`;
  const markerB = `color%3Ared|label%3AB|${destination.lat}%2C${destination.lng}`;

  return (
    <div className={classes}>
      <img src={`https://maps.googleapis.com/maps/api/staticmap?size=${size}&maptype=roadmap&key=${apiKey}&markers=${markerA}&markers=${markerB}&scale=2`} />
    </div>
  );
};
